import { useMemo } from 'react';

import { useCurrentUserQuery } from '@query';

import { WalletNetwork } from '@api';

const useMagicIdWallet = (targetNetwork: WalletNetwork = 'EVM') => {
  // NOTE: the same as { user } = useAuth()
  // useCurrentUserQuery is used to make useUserWalletInfo reusable without using AuthProvider
  const { data: user, isFetching } = useCurrentUserQuery({
    enabled: false,
  });

  const userWallet = useMemo(
    () => user?.wallets?.find((wallet) => wallet.attributes.network === targetNetwork),
    [user, targetNetwork],
  );

  const isAuthed = user && !isFetching;

  return {
    user,
    userWallet,
    isLoadingUser: isFetching,
    isAuthed,
  };
};

export default useMagicIdWallet;
